/* @startCleanup encore */
import { BannerProps as FabricBannerProps } from '@bamboohr/fabric';

export enum SetupType {
	QUICKSTART = 'quickStart',
	PAYROLL = 'payroll',
	CORE_IMPLEMENTATION = 'core',
}

export interface BannerData {
	type: SetupType;
	stepKey?: string;
	taskKey?: string;
	recordId?: string;
	clientId?: string;
	dataPath?: string;
	biId?: string;
	title: string;
	primaryUrl?: string;
	secondaryUrl?: string;
	progressNote?: string;
	subtitle?: string;
	buttonText?: string;
}

export type SetupSummaryBannerProps = Omit<BannerData, 'type' | 'stepKey' | 'taskKey' | 'dataPath'> & {
	onClose: FabricBannerProps['onClose'];
	progress?: {
		current: number;
		total: number;
	};
};
/* @endCleanup encore */
